<template>
  <div class="b-settings__block p-6 pb-8 mt-6">
    <h2 class="mb-4">{{$t('CONTENT.settingsPage.payment_settings')}}</h2>
    <form v-if="isLoaded" class="b-form p-0" @submit.prevent="onSubmit">
      <div class="row mt-5">
        <div class="col-12">
          <checkbox class="b-checkbox" id="isShowInfo" v-model="isShowInfo">{{$t('CONTENT.settingsPage.payment_settings_note')}}</checkbox>
        </div>
      </div>
      <button
        class="b-btn b-btn_type_primary mt-4"
        type="submit"
        :disabled="isDisabledSaveBtn"
      >{{$t('CONTENT.save')}}</button>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentSettings',
  data() {
    return {
      isDisabledSaveBtn: true,
      additionalPaymentsInCharts: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
    isShowInfo: {
      get() {
        if (this.additionalPaymentsInCharts === null) {
          this.additionalPaymentsInCharts = this.getContractSettings.additionalPaymentsInCharts;
        }
        return this.additionalPaymentsInCharts;
      },
      set(newVal) {
        this.additionalPaymentsInCharts = newVal;
        this.isDisabledSaveBtn = false;
      },
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.$loadingManager.addLoadingStep();
        await this.$store.dispatch('setContractSettings', { additionalPaymentsInCharts: this.additionalPaymentsInCharts });
        this.isDisabledSaveBtn = true;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
      }
    },
  },
};
</script>
